import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import StoreSelect from '@/components/StoreSelect'
import StoreList from '@/components/StoreList'
import Receive from '@/components/ReceiveMethod'
import MenuCategory from '@/components/MenuCategory'
import Coupon from '@/components/Coupon'
import MenuList from '@/components/MenuList'
import SetMenuList from '@/components/SetMenuList'
import SetMenuDetail from '@/components/SetMenuDetail'
import Cart from '@/components/Cart'
import OrderFixing from '@/components/OrderFixing'
import TableOrderSelect from '@/components/TableOrderSelect'
import TableOrderInput from '@/components/TableOrderInput'
import TableOrderConfirm from '@/components/TableOrderConfirm'
import PaymentMethod from '@/components/PaymentMethod'
import InputCreditCard from '@/components/InputCreditCard'
import ConfirmCreditCard from '@/components/ConfirmCreditCard'
import InputMFCard from '@/components/InputMFCard'
import OrderProcessing from '@/components/OrderProcessing'
import OrderFailed from '@/components/OrderFailed'
import DconnectCall from '@/components/DconnectCall'
import DconnectAuth from '@/components/DconnectAuth'
import ErrorPage from '@/components/Error'
import OrderComplete from '@/components/OrderComplete'
import OrderHistory from '@/components/OrderHistory'
import UserPolicy from '@/components/UserPolicy'
import Tokusho from '@/components/Tokusho'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/mo-site/',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/store/select',
      name: 'StoreSelect',
      component: StoreSelect
    },
    {
      path: '/store/list',
      name: 'StoreList',
      component: StoreList
    },
    {
      path: '/receive-method',
      name: 'ReceiveMethod',
      component: Receive
    },
    {
      path: '/menu/category',
      name: 'MenuCategory',
      component: MenuCategory
    },
    {
      path: '/menu/coupon',
      name: 'Coupon',
      component: Coupon
    },
    {
      path: '/menu/list',
      name: 'MenuList',
      component: MenuList
    },
    {
      path: '/menu/setmenu/list',
      name: 'SetMenuList',
      component: SetMenuList
    },
    {
      path: '/menu/setmenu/detail',
      name: 'SetMenuDetail',
      component: SetMenuDetail
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart
    },
    {
      path: '/order/fixing',
      name: 'OrderFixing',
      component: OrderFixing
    },
    {
      path: '/tableorder/select',
      name: 'TableOrderSelect',
      component: TableOrderSelect
    },
    {
      path: '/tableorder/input',
      name: 'TableOrderInput',
      component: TableOrderInput
    },
    {
      path: '/tableorder/confirm',
      name: 'TableOrderConfirm',
      component: TableOrderConfirm
    },
    {
      path: '/payment/method',
      name: 'PaymentMethod',
      component: PaymentMethod
    },
    {
      path: '/payment/creditcard',
      name: 'InputCreditCard',
      component: InputCreditCard
    },
    {
      path: '/payment/creditcard/confirm',
      name: 'ConfirmCreditCard',
      component: ConfirmCreditCard
    },
    {
      path: '/payment/mfcard',
      name: 'InputMFCard',
      component: InputMFCard,
      children: [
        {
          name: 'InputMFCardChargeComplete',
          path: '/payment/mfcard/charge/complete',
          component: InputMFCard
        }
      ]
    },
    {
      path: '/order/processing',
      name: 'OrderProcessing',
      component: OrderProcessing
    },
    {
      path: '/order/failed',
      name: 'OrderFailed',
      component: OrderFailed
    },
    {
      path: '/dcm/entry',
      name: 'DconnectCall',
      component: DconnectCall
    },
    {
      path: '/dcm/authresult',
      name: 'DconnectAuth',
      component: DconnectAuth
    },
    {
      path: '/error',
      name: 'ErrorPage',
      component: ErrorPage
    },
    {
      path: '/user/policy',
      name: 'UserPolicy',
      component: UserPolicy
    },
    {
      path: '/tokusho',
      name: 'Tokusho',
      component: Tokusho
    },
    {
      path: '/order/complete',
      name: 'OrderComplete',
      component: OrderComplete
    },
    {
      path: '/order/history',
      name: 'OrderHistory',
      component: OrderHistory
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js